var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.393 11.992h-.06a.665.665 0 0 1-.666-.729l.286-2.788c.03-.305.165-.59.38-.809l6-6.017a1.33 1.33 0 0 1 1.774.047l1.826 1.832a1.285 1.285 0 0 1 .047 1.812l-6 6.017c-.217.216-.502.35-.807.381l-2.78.254ZM12 4.457l-1.82-1.825-1.3 1.337 1.787 1.792L12 4.457Zm-4 .395L4.247 8.589l-.18 2 2-.188L9.8 6.657 8 4.852Zm-4.667 8.477h9.334a.666.666 0 0 1 .666.67.67.67 0 0 1-.666.668H3.333a.666.666 0 0 1-.666-.669.67.67 0 0 1 .666-.668Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.3d6d333b973980c9ac415a5af8597e2f.svg";
export { ForwardRef as ReactComponent };